import React from 'react';
import { usePagoUnico } from '~/store/States/pospago';
import '~/sass/modules/_pagoUnico.scss';

export default function PagoUnico() {
  const pagoUnico = usePagoUnico();
  if (!pagoUnico) return null;
  return (
    <div className="pospago--pago-unico" style={{ backgroundColor: pagoUnico.color }}>
      <span className="label">{pagoUnico.indicador}</span>
    </div>
  );
}
